import React from 'react';
function LineHeight({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M11.8985 6.60645H19.8115M12.0869 12.0004H19.9999M11.8984 17.3943H19.8115"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 8L6 6M6 6L8 8M6 6V18M8 16L6 18M6 18L4 16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LineHeight;
